import React from 'react';

import autoBind from 'react-autobind';

import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "../Config.jsx";

import Localization from "../Localization.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';

import ReactHtmlParser from 'react-html-parser';

class AccountDisabledDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      account_disable_level: 0,
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  btnOKClicked() {
    this.setState({open: false});
    this.state.open = false;
    this.props.parent.agreementCheck();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.ACCOUNT_DISABLING_INFO_TITLE}
          </DialogTitle>
          <DialogContent>
            {this.state.account_disable_level == 1 ? Localization.strings.ACCOUNT_DISABLING_CONTENT_LV1 : Localization.strings.ACCOUNT_DISABLING_CONTENT_LV2}
          </DialogContent>
          <If condition={this.state.account_disable_level == 1}>
            <Then>
                <DialogActions style={{padding:'16px 24px'}}>
                    <Button
                    onClick={this.btnOKClicked}
                    color="primary"
                    variant="contained"
                    >
                    {Localization.strings.OK}
                    </Button>
                </DialogActions>
            </Then>
          </If>
        </Dialog>
      </div>
    )
  }
}

export default AccountDisabledDialog;
